module.exports = __webpack_public_path__ + "media/img/auth/campus-cap-mobile-016a460b1f803653be31bd483dc147bc.png";